import styled from 'shared/utils/styled';

type StyledStatusProps = {
  status: number | null;
};

export const Status = styled('span')<StyledStatusProps>(
  ({ theme, status }) => ({
    color:
      typeof status === 'number'
        ? status === 7
          ? theme.palette.error.main
          : status === 4
          ? theme.palette.warning.main
          : status === 5
          ? theme.palette.success.main
          : theme.palette.primary.main
        : theme.palette.primary.main,
  })
);

export const Divider = styled('span')(() => ({
  color: '#fff',
}));

export const Label = styled('span')(() => ({
  display: 'block',
  marginBottom: 10,
  fontSize: 15,
  fontWeight: 600,
  color: '#fff',
}));
